const VIDEO_FILE_REGEXP = /\.(mp4|webm|mov|avi|m4v)(?:[?#].*)?$/i

function normalizeMediaUrl(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function normalizeMediaType(value) {
  return typeof value === 'string' ? value.trim().toUpperCase() : ''
}

/**
 * @description 按当前视口解析聚合页营销资源；H5 未配置时回退 PC 资源。
 * @param {Object} product
 * @param {{mobile?: boolean}} [options]
 * @returns {{imageUrl: string, kind: string, url: string, videoUrl: string}}
 */
export function resolveAggregateHomeCardMedia(product = {}, options = {}) {
  const mobile = options.mobile === true
  const desktopMarketingMediaUrl = normalizeMediaUrl(product.mediaUrl || product.marketingMedia)
  const h5MarketingMediaUrl = normalizeMediaUrl(product.h5MediaUrl)
  const marketingMediaUrl = mobile
    ? h5MarketingMediaUrl || desktopMarketingMediaUrl
    : desktopMarketingMediaUrl
  const fallbackImageUrl = normalizeMediaUrl(product.pic || product.image)
  const videoCoverUrl = mobile
    ? normalizeMediaUrl(product.h5VideoCoverUrl || product.videoCoverUrl)
    : normalizeMediaUrl(product.videoCoverUrl)
  const primaryUrl = marketingMediaUrl || fallbackImageUrl

  if (!primaryUrl) {
    return {
      imageUrl: '',
      kind: '',
      url: '',
      videoUrl: '',
    }
  }

  const mediaType = normalizeMediaType(
    mobile ? product.h5MediaType || product.mediaType : product.mediaType
  )
  const isVideo =
    Boolean(marketingMediaUrl) &&
    (mediaType === 'VIDEO' || (mediaType !== 'IMAGE' && VIDEO_FILE_REGEXP.test(marketingMediaUrl)))

  if (isVideo) {
    return {
      imageUrl:
        videoCoverUrl ||
        (fallbackImageUrl && fallbackImageUrl !== marketingMediaUrl ? fallbackImageUrl : ''),
      kind: 'video',
      url: marketingMediaUrl,
      videoUrl: marketingMediaUrl,
    }
  }

  return {
    imageUrl: primaryUrl,
    kind: 'image',
    url: primaryUrl,
    videoUrl: '',
  }
}
